module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@6.25.0@babel-runtime/core-js/object/define-property.js
// module id = 143
// module chunks = 20